import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import { Typography } from '@heroui/react';
import { KPI } from '@heroui-pro/react/kpi';
import type { RevenueDynamics } from '@/api/models';
import { getNodeTestIdProp } from '@/utils';
import { RevenueDynamicsKpiValue } from './RevenueDynamicsKpiValue';
import {
    REVENUE_DYNAMICS_KPI_LABEL_KEY,
    REVENUE_DYNAMICS_KPI_GRID_CLASS,
    REVENUE_DYNAMICS_KPI_DECORATION,
    REVENUE_DYNAMICS_KPI_SLOTS,
} from './revenueDynamicsMeta';

type RevenueDynamicsKpisProps = { data: RevenueDynamics };

export const RevenueDynamicsKpis = ({ data }: RevenueDynamicsKpisProps) => {
    const { t } = useTranslation('pages');

    return (
        <ul
            className={REVENUE_DYNAMICS_KPI_GRID_CLASS}
            {...getNodeTestIdProp('revenue-dynamics-kpis')}
        >
            {REVENUE_DYNAMICS_KPI_SLOTS.map((slot) => {
                const decoration = REVENUE_DYNAMICS_KPI_DECORATION[slot];
                return (
                    <li
                        key={slot}
                        className="min-w-0"
                        {...getNodeTestIdProp(`revenue-dynamics-kpi-${slot}`)}
                    >
                        <KPI className="h-full">
                            <KPI.Header>
                                {decoration && (
                                    <Icon
                                        aria-hidden="true"
                                        icon={decoration.icon}
                                        className="size-4 shrink-0 text-warning-soft-foreground"
                                    />
                                )}
                                <KPI.Title>
                                    {t(REVENUE_DYNAMICS_KPI_LABEL_KEY[slot])}
                                </KPI.Title>
                            </KPI.Header>
                            <KPI.Content className="grid-cols-1 content-start">
                                <RevenueDynamicsKpiValue
                                    data={data}
                                    slot={slot}
                                />
                                {decoration && (
                                    <Typography.Paragraph
                                        size="xs"
                                        color="muted"
                                    >
                                        {t(decoration.subtitleKey, {
                                            count: data.summary.transactions,
                                            discounted:
                                                data.summary
                                                    .discountedTransactions,
                                        })}
                                    </Typography.Paragraph>
                                )}
                            </KPI.Content>
                        </KPI>
                    </li>
                );
            })}
        </ul>
    );
};
